/**
 * FRIDGE-1324 — one shared fact: is the Frosty chat panel open right now?
 *
 * The chat widget writes it; the sitewide capture popup reads it, so a dialog
 * never slides over an open conversation. The homepage used to carry this as a
 * stylesheet rule on its own canvas, which never reached product pages — the
 * owner's phone screenshot shows the Price Watch card covering the chat input.
 * A module-level store keeps the two components apart: neither imports the
 * other's markup, and a test can drive the fact without mounting the widget.
 */
type Listener = () => void

let panelOpen = false
const listeners = new Set<Listener>()

export function isFrostyPanelOpen(): boolean {
  return panelOpen
}

export function setFrostyPanelOpen(next: boolean): void {
  if (panelOpen === next) return
  panelOpen = next
  for (const listener of listeners) listener()
}

export function subscribeFrostyPanelOpen(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Test seam: forget every subscriber and close the panel. */
export function resetFrostyPanelStateForTests(): void {
  panelOpen = false
  listeners.clear()
}
